import React, { useState } from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { Formik, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import ProductionLogs from 'src/components/ProductionLogs';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  search: {
    padding: `0 ${theme.spacing(2)}px`
  },
  resultsDivider: {
    marginTop: theme.spacing(2)
  }
}));

function ProductionLogSearch({ className, ...rest }) {
  const classes = useStyles();

  const [input, setInput] = useState('');
  const [vin, setVin] = useState();
  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardHeader title="Search Production Logs" />
      <Divider />
      <CardContent className={classes.content}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className={classes.search}>
              <TextField
                fullWidth
                label="Vin"
                name="vin"
                value={input}
                onBlur={e => setVin(e.target.value)}
                onChange={e => setInput(e.target.value)}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    e.target.blur();
                  }
                }}
              />
            </div>
          </Grid>
        </Grid>
        {vin && (
          <Grid item xs={12}>
            <Divider className={classes.resultsDivider} />

            <ProductionLogs vin={vin} />
          </Grid>
        )}
      </CardContent>
    </Card>
  );
}

ProductionLogSearch.propTypes = {
  className: PropTypes.string
};

export default ProductionLogSearch;
